<div class="user-profile-modal">
  <app-spinner *ngIf="loading"></app-spinner>
  <form #userProfileForm="ngForm"  *ngIf="!loading">
    <h2 md-dialog-title>
      <span *ngIf="profile.id">Edit {{profile.value}}</span>
      <span *ngIf="!profile.id">New profile</span>
    </h2>
    <md-dialog-content>
      <div class="sections">
        <div class="section">
          <h4>Profile information</h4>
          <div class="subsection">
            <md-form-field *ngIf="editMode">
              <input mdInput name="name" placeholder="Name" [(ngModel)]="profile.value" [required]="true">
            </md-form-field>
            <h4 *ngIf="!editMode">{{profile.value}}</h4>
          </div>
        </div>
      </div>
      <hr>
      <app-checkbox-table #checkboxTable [profiles]="[]" [editMode]="editMode" [privileges]="profile.privileges" (userPrivilegesUpdated)="userPrivilegesUpdated()"></app-checkbox-table>
    </md-dialog-content>
    <md-dialog-actions *ngIf="editMode">
      <div>
        <button md-raised-button (click)="deleteProfile()" color="warn" *ngIf="profile.id">
            <md-icon>delete</md-icon>  
            Delete
          </button>
      </div>
      <div>
        <button md-raised-button md-dialog-close>
            <md-icon>cancel</md-icon>  
            Cancel
          </button>
        <button md-raised-button (click)="saveUserProfile()" color="accent" [disabled]="!userProfileForm.valid || profile.privileges.length === 0">
            <md-icon>save</md-icon>  
            Save
          </button>
      </div>
    </md-dialog-actions>
    <md-dialog-actions *ngIf="!editMode">
      <div>
      </div>
      <div>
        <button md-raised-button md-dialog-close>Close</button>
      </div>
    </md-dialog-actions>
  </form>
</div>




// WEBPACK FOOTER //
// ./src/app/modals/user-profile-modal/user-profile-modal.component.html